<template>
  <v-dialog :value="open" persistent scrollable max-width="700px">
    <v-card>
      <v-toolbar color="primary" dark flat dense>
        <v-toolbar-title>{{ $t('listaPreciosVenta.editing') }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$emit('close')"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <template v-if="!showConfirm">
        <v-card-text v-if="error" class="pb-0 pt-3">
          <v-alert type="error" dense text>{{ error }}</v-alert>
        </v-card-text>
        <v-card-text>
          <lista-precios-venta-form ref="form" v-model="form" />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="$emit('close')">{{ $t('common.cancel') }}</v-btn>
          <v-btn color="primary" :loading="saving" @click="onUpdateClick">
            {{ $t('common.update') || $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </template>

      <template v-else>
        <v-card-text class="pt-5">
          <v-icon color="warning" size="40" class="mb-3">warning</v-icon>
          <div class="text-subtitle-1 font-weight-medium mb-3">
            Confirmar cambios en lista de precios
          </div>
          <template v-if="formulaConfigCambio">
            <p>
              La configuración de <strong>{{ form.nombre }}</strong> cambiará.
            </p>
            <code class="formula-confirm-code d-block pa-2 mb-3">
              {{ form.formulaConfig && form.formulaConfig.formula }}
            </code>
            <v-alert type="warning" dense text>
              Esto recalculará el precio de venta de todos los productos asociados a esta lista.
            </v-alert>
          </template>
          <p v-else>
            ¿Confirmar los cambios en la lista <strong>{{ form.nombre }}</strong>?
          </p>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="showConfirm = false">Volver</v-btn>
          <v-btn color="primary" :loading="saving" @click="save">
            Confirmar y guardar
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import ListaPreciosVentaProvider from "../../../providers/ListaPreciosVentaProvider";
import ListaPreciosVentaForm from "../ListaPreciosVentaForm";

export default {
  name: "ListaPreciosVentaUpdate",
  components: { ListaPreciosVentaForm },
  props: { open: Boolean, item: { type: Object, required: true } },
  data() {
    const cfg = this.item.formulaConfig || {};
    return {
      saving: false,
      error: null,
      showConfirm: false,
      form: {
        nombre: this.item.nombre || "",
        formulaConfig: {
          formula: cfg.formula || "",
          margenDefault: cfg.margenDefault != null ? cfg.margenDefault : null,
          tipoRedondeo: cfg.tipoRedondeo != null ? cfg.tipoRedondeo : null,
        },
      },
    };
  },
  computed: {
    formulaConfigCambio() {
      const anterior = this.item.formulaConfig || {};
      const nueva = this.form.formulaConfig || {};
      return JSON.stringify(anterior) !== JSON.stringify(nueva);
    },
  },
  methods: {
    onUpdateClick() {
      if (!this.$refs.form.validate()) return;
      this.showConfirm = true;
    },
    save() {
      this.saving = true;
      this.error = null;
      const input = {
        nombre: this.form.nombre,
        formulaConfig: this.form.formulaConfig,
      };
      ListaPreciosVentaProvider.update(this.item.id, input)
        .then(() => this.$emit("itemUpdated"))
        .then(() => this.$emit("close"))
        .catch((err) => {
          this.error = err.message;
        })
        .finally(() => {
          this.saving = false;
          this.showConfirm = false;
        });
    },
  },
};
</script>

<style scoped>
.formula-confirm-code {
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 12px;
  word-break: break-all;
}
</style>
